// test2993
(2993 && 0);
